import Vue from 'vue';
import { mapState, mapActions, mapGetters } from "vuex";
import { mapKeysToState } from "components/DataWidgets/DataWidgetUtils";
import { BfButton } from 'components/Butterfly';
import { FETCH_DATA } from 'src/store/types';
import vueJsonEditor from 'vue-json-editor';
const PivotToolPage = Vue.extend({
    name: "PivotToolPage",
    components: { BfButton, vueJsonEditor },
    props: {
        projectId: { type: Number, required: false, default: null },
        analysisId: { type: Number, required: false, default: null },
    },
    data() {
        return {
            dataKey: null,
            blocks: [
                {
                    "aggfuncs": [
                        {
                            "new_column": "frequency",
                            "src_column": "document_id",
                            "aggfunc": "count",
                        }
                    ],
                }
            ],
            agg_field: null,
            queries: []
        };
    },
    computed: {
        ...mapGetters([
            'savedQueries',
            'sortedFieldsUnlimited',
            'currentProject',
            'currentAnalysis',
            'currentSite'
        ]),
        ...mapState({
            fetchedData(state) {
                return mapKeysToState(state.data, [this.dataKey]);
            }
        }),
        isData() {
            return this.fetchedData &&
                this.fetchedData['0'] &&
                this.fetchedData['0'].data &&
                this.fetchedData['0'].data.payload &&
                this.fetchedData['0'].data.payload.length > 0;
        },
        tableData() {
            return this.fetchedData &&
                this.fetchedData['0'] &&
                this.fetchedData['0'].data &&
                this.fetchedData['0'].data.payload
                ? this.fetchedData['0'].data.payload : [];
        },
        columns() {
            return this.fetchedData[0]?.data?.payload && this.fetchedData[0]?.data?.payload.length > 0 ? Object.keys(this.fetchedData[0].data.payload[0]) : [];
        },
        requirements() {
            return {
                blocks: this.blocks,
                agg_fields: [this.agg_field === 'sentiment' ? 'sentiment__' : this.agg_field],
                queries: this.queries.map(q => ({
                    name: q,
                    value: this.savedQueries.find(sq => sq.name === q).query_value
                })),
                identity: 'pivot_tool_page'
            };
        }
    },
    methods: {
        ...mapActions({ FETCH_DATA }),
        async run() {
            const key = await this.FETCH_DATA({
                params: {
                    projectId: this.projectId,
                    analysisId: this.analysisId,
                    topicId: this.currentAnalysis.topic_framework_id,
                    chrysalisRef: this.currentProject.chrysalis_ref,
                    chrysalis_url: this.currentSite.chrysalis_url
                },
                requirements: this.requirements
            });
            this.dataKey = key;
        }
    }
});
export default PivotToolPage;
